module.exports = __webpack_public_path__ + "static/media/sketch.c007d565.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/sketch.png
// module id = 191
// module chunks = 0